export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          {/* Visual */}
          <div className="flex-shrink-0 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20digital%20reading%20illustration%2C%20warm%20coral%20and%20cream%20toned%20artwork%2C%20stylized%20bookshelf%20with%20colorful%20manga%20volumes%2C%20comfortable%20reading%20nook%20scene%2C%20soft%20ambient%20lighting%2C%20inviting%20atmosphere%2C%20modern%20flat%20illustration%20style%2C%20high%20detail%20editorial%20quality&width=1200&height=900&seq=about-section-2026&orientation=landscape"
                alt="九妖漫画网品牌介绍 - 免费漫画阅读平台"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div className="flex-1 w-full">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
              <i className="ri-information-line"></i>
              关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              关于九妖漫画网
            </h2>
            <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-3">
              <p>
                九妖漫画网成立于2020年，是专注为中文漫画爱好者打造的<strong>免费漫画在线阅读平台</strong>。我们汇聚了涵盖<strong>国漫推荐</strong>、<strong>日漫精选</strong>、<strong>韩漫热门</strong>等多元品类漫画资源，致力于为广大漫迷提供便捷、流畅的<strong>免费漫画全集</strong>阅读服务。
              </p>
              <p>
                平台采用创新的<strong>下拉式漫画</strong>阅读模式，读者无需反复翻页即可连续畅读，带来沉浸式的追更体验。每日同步更新最新漫画章节，覆盖热血、恋爱、玄幻、都市、悬疑、搞笑等多个题材，无论是新读者还是资深漫迷，都能在这里找到属于自己的阅读天地。
              </p>
              <p>
                我们始终坚持以用户为中心，提供<strong>免费全集大全</strong>漫画资源，让每一位漫画爱好者都能无门槛享受精彩的漫画世界。
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-6 mt-6">
              <div className="flex items-center gap-2">
                <span className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full">
                  <i className="ri-shield-check-line"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">正版授权</div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">内容合规</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-full">
                  <i className="ri-group-line"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">500万+</div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">活跃用户</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-10 h-10 flex items-center justify-center bg-secondary-100 text-secondary-600 rounded-full">
                  <i className="ri-time-line"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">每日更新</div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">稳定运营</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}